import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import MultySearchSelect from "utils/MultySearchSelect";
import SearchSelect from "utils/SearchSelect";
import extractValues from "utils/extractValues";
import initItem from "utils/initItem";
import { cleanArray } from "utils/editHelper";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const status = [
  { label: "برنامه ریزی شده", value: "scheduled" },
  { label: "درحال اجرا", value: "ongoing" },
  { label: "تکمیل شده", value: "completed" },
  { label: "به تعویق افتاد", value: "postponed" },
  { label: "کنسل شده", value: "canceled" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    league: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    homeTeam: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    awayTeam: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    winner: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
            ]);

            const result = extractValues(clean, [
              "league",
              "homeTeam",
              "awayTeam",
              "winner",
            ]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام:"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="name(en)"
                    label="name(en) :"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="intro-y">
                    <Field
                      label="لیگ مرتبط :"
                      name="league"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="leagueNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ بازی :"
                      name="matchDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <div className="intro-y">
                    <span> شماره هفته بازی در لیگ :</span>
                    <Field
                      label="شماره هفته بازی در لیگ : "
                      name="weekNumber"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم میزبان:"
                      name="homeTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" تیم مهمان:"
                      name="awayTeam"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="وضعیت بازی :"
                      name="status"
                      component={Select}
                      options={status}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم میزبان :</span>
                    <Field
                      label="تعداد گل تیم میزبان  : "
                      name="homeGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <span> تعداد گل تیم مهمان :</span>
                    <Field
                      label="تعداد گل تیم مهمان  : "
                      name="awayGoals"
                      component="input"
                      type="number"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" برنده:"
                      name="winner"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="teamNew"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <Field
                    placeholder="لینک پخش زنده بازی"
                    label="لینک پخش زنده بازی :"
                    name="broadcastUrl"
                    component={TextField}
                  />

                  <Field
                    placeholder="زمان شروع بازی"
                    label="زمان شروع بازی :"
                    name="startTime"
                    component={TextField}
                  />
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
